import { softDelete, timestamps, uuid } from '@snap-types/models/common';
import {
  LeadTimeStrategy,
  leadTimeStrategySchema,
} from '@snap-types/models/enums';
import { schema } from '@snap-types/schemas';
import { z } from 'zod/v4';

export const columns = {
  uuid,
  sortOrder: z.int().default(0),
  leadTimeType: leadTimeStrategySchema,
  priceStrategyConfigUuid: uuid,

  days: z.number().nullish(),
  nasPartDays: z.number().nullish(),
  defaultDays: z.number().nullish(),

  createdByUserUuid: uuid.nullish(),
  ...timestamps,
  ...softDelete,
} as const;

export const constantValueColumns = z.object({
  leadTimeType: z.literal(LeadTimeStrategy.CONSTANT_VALUE),
  days: schema.t.num.fromString.pipe(schema.t.int.nonNegative),
});

export const planningLeadTimeColumns = z.object({
  leadTimeType: z.literal(LeadTimeStrategy.PLANNING_LEADTIME),
});

export const rafFixedMarketColumns = z.object({
  leadTimeType: z.literal(LeadTimeStrategy.RAF_FIXED_MARKET),
  nasPartDays: schema.t.num.fromString.pipe(schema.t.int.nonNegative),
  defaultDays: schema.t.num.fromString.pipe(schema.t.int.nonNegative),
});
